import { Box, HStack, Stack, Text } from '@chakra-ui/react';
import { useTranslation } from 'next-i18next';

import SmallJust from '$components/SvgLogos/SmallJust';
import { useIsDesktop } from '$src/hooks/client/useIsDesktop';
import { useShop } from '$src/hooks/queries';

export const PaidLoader = () => {
  const { t } = useTranslation();
  const { data: shop } = useShop();
  const { isMobile } = useIsDesktop();
  return (
    <Box
      position="absolute"
      top="0"
      left="0"
      as="main"
      flex="1 1 auto"
      overflow="auto"
      p="0"
      m="0"
      height="full"
      width="full"
      display="flex"
      backgroundColor="rgba(0, 0, 0, 0.60) !important"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      alignContent="center"
      alignSelf="center"
      zIndex="10000"
    >
      <Stack
        display="flex"
        alignItems="center"
        alignContent="center"
        alignSelf="center"
        backgroundColor="var(--card-bg, #FFF)"
        pb="2rem"
        px="0.7rem"
        justifyContent="center"
        w={isMobile ? '21.56rem' : '25.5rem'}
        h={isMobile ? '10rem' : '12rem'}
        borderRadius="1.5rem"
        border="1px #8DE690"
        filter="drop-shadow(0px 0px 10px rgba(0, 0, 0, 0.10))"
        gap="0"
      >
        <Text color="var(--text, #1C1C1C)" textAlign="center" fontWeight="medium" lineHeight="6">
          {t('loader.processing')}
        </Text>
        <Text color="var(--text, #1C1C1C)" textAlign="center" fontWeight="medium" lineHeight="6">
          {t('loader.dontRefresh')}
        </Text>

        {shop?.name !== undefined && (
          <HStack
            spacing={1}
            position="absolute"
            bottom="4"
            left="50%"
            transform="translateX(-50%)"
            maxW="calc(100% - 2rem)"
          >
            <SmallJust />
            <Text
              textAlign="center"
              fontSize="xs"
              fontWeight="350"
              lineHeight="md"
              minW={0}
              isTruncated
              color="var(--text-muted, #8F8F8F)"
            >
              {t('loader.authorizedBy')} {shop.name}
            </Text>
          </HStack>
        )}
      </Stack>
    </Box>
  );
};
